<script lang="ts" setup>
import { ref } from 'vue'
import AdkButton from '@components/ui/AdkButton.vue'
import ConfirmDialog from '@components/ui/modal/ConfirmDialog.vue'
import { useCartActions } from '@composables/useCartActions'
import { useLocale } from '@composables/useLocale'
import { useToast } from '@composables/useToast'
import { useGtm } from '@composables/useGtm'
import { ConfirmDialogProps } from '@lib/models/modals'
import { createConfirmDialog } from 'vuejs-confirm-dialog'
import { GTMContentGroup } from '@lib/models/gtm'

const { t } = useLocale()
const { resetCartToEmpty } = useCartActions()
const { showToast } = useToast()
const { trackEmptyCart, trackOnCloseModal, trackEmptyCartConfirmation } = useGtm()

const fetching = ref<boolean>(false)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dialog = createConfirmDialog(ConfirmDialog as any)

const actionEmptyCart = async () => {
  const dialogProps: ConfirmDialogProps = {
    title: t('quieres_vaciar_el_carrito'),
    description: t('se_eliminaran_todos_los_productos_que_agregaste_a_tu_pedido'),
    primaryButton: t('vaciar_carrito'),
    secondaryButton: t('Cancelar'),
    imageUrl: 'images/icons/cart-bag-error.svg',
    contentGroup: {
      cg: GTMContentGroup.primary.ECOMMERCE,
      cg2: GTMContentGroup.secondary.EMPTY_CART
    },
    customClass: '[&_img]:w-[calc(246*var(--vw))] [&_img]:!h-[auto]'
  }
  trackEmptyCart()
  const { isCanceled } = await dialog.reveal(dialogProps)

  if (isCanceled) return trackOnCloseModal()

  fetching.value = true
  trackEmptyCartConfirmation()
  const resetted = await resetCartToEmpty()
  fetching.value = false
  if (!resetted) {
    // handle error
    showToast({
      type: 'error',
      text: t('algo_salio_mal_ntentalo_otra_vez')
    })
  }
  trackOnCloseModal()
}
</script>

<template>
  <AdkButton
    class="w-1/2"
    size="medium"
    data-test="btn-empty-cart"
    :disabled="fetching"
    @press="actionEmptyCart"
  >
    {{ t('vaciar_carrito') }}
  </AdkButton>
</template>
